import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// In-memory cache — one fetch per session
let _cache = null;
let _promise = null;

async function fetchOverrides() {
  if (_cache) return _cache;
  if (_promise) return _promise;
  _promise = axios
    .get(`${API}/pricing/plans`)
    .then((res) => {
      const map = {};
      (res.data.plans || []).forEach((p) => {
        map[p.id] = p; // { base_inr, total_inr, base_usd, total_usd, ... }
      });
      _cache = map;
      return map;
    })
    .catch(() => {
      _cache = {};
      return {};
    })
    .finally(() => {
      _promise = null;
    });
  return _promise;
}

/** Returns { [planId]: { base_inr, total_inr, base_usd, total_usd } } */
export function usePlanPrices() {
  const [prices, setPrices] = useState(_cache || {});
  useEffect(() => {
    if (_cache) return;
    let mounted = true;
    fetchOverrides().then((m) => {
      if (mounted) setPrices(m);
    });
    return () => {
      mounted = false;
    };
  }, []);
  return prices;
}

/** Overwrite ALL_PLANS[].price with backend base_inr (respects admin overrides). */
export function applyLivePrices(plans, priceMap) {
  if (!priceMap || !Object.keys(priceMap).length) return plans;
  return plans.map((p) => {
    const live = priceMap[p.id];
    if (live && typeof live.base_inr === 'number') {
      return { ...p, price: live.base_inr, base_usd: live.base_usd };
    }
    return p;
  });
}
